import React, { useEffect, useState } from "react";
import { Col, Form, Row, Tab, Tabs } from "react-bootstrap";
import toast from "react-hot-toast";
import Select from "react-select";
import { useNavigate } from "react-router-dom";
import Navbar from "../../../Components/Navbar/Navbar";
import {
    getBranchId,
    getTodayDate,
    getType,
    selectDropdownStyle
} from "../../../Helpers/Utils/Common";
import DatePicker from "react-datepicker";
import Moment from "moment";
import { Line } from "react-chartjs-2";
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    BarElement,
    ArcElement,
    Title,
    Tooltip,
    Legend,
  } from "chart.js";
  
import { getAllBranches } from "../../../Helpers/apiCalls/Manage/Branches";
import { searchPeakHours } from './../../../Helpers/apiCalls/Reports/DailyUsageApi';
import NoDataImg from "./../../../Assets/Images/no-data-img.png"
import Footer from "../../../Components/Footer/Footer";

export default function PeakHours() {
    let navigate = useNavigate();
    var dateToday = getTodayDate();
    const accountType = getType();

    const [inactive, setInactive] = useState(true);
    const [filterConfig, setFilterConfig] = useState({
        branch_id: (accountType === "branch_oic" || accountType === "branch_inventory_officer") ? getBranchId() : "",
    })
    const [branches, setBranches] = useState([]);
    const [showLoader, setShowLoader] = useState(false);
    const [noData, setNoData] = useState(false);
    const [hours, setHours] = useState([]);
    const [orders, setOrders] = useState([]);
    const [totalQuantity, setTotalQuantity] = useState([]);

    const data = {
        labels: hours,
        datasets: [
          {
            label: "Peak Hours",
            data: orders,
            fill: true,
            backgroundColor: "var(--primary-color) ",
            borderColor: "var(--primary-color) "
          },
        ]
      };

    // SEARCH USER
    function handleOnSearch(e) {
        const { name, value } = e.target;
        setFilterConfig((prev) => {
            return { ...prev, [name]: value };
        });
    }

    async function fetchBranches() {
        setShowLoader(true);
        setBranches([])
        
            const response = await getAllBranches();
            if (response.error) {
            } else {
                var allBranches = response.data.data.data
                .filter((data) => { return (data.is_franchise !== "3" && data.is_franchise !== "1")})
                .map((data) => {
                    var branch = data;
                    branch.label = data.name
                    branch.value = data.id
                    branch.id = data.id
                    return branch;
                });
                setFilterConfig((prev) => ({...prev, branch_id: allBranches[0].value}))
                if(accountType === "branch_oic" || accountType === "branch_inventory_officer") {
                    var filteredBranch = allBranches.filter((data) => {
                    return data.id === getBranchId()
                    })
                    setBranches(filteredBranch);
                } else {
                    setBranches([{label: "All Branches", value:""}, ...allBranches]);
                }
            }
        setShowLoader(false);
    }


    async function fetchData() {
        setShowLoader(true);
        setTotalQuantity(0);

        const response = await searchPeakHours(filterConfig);
        

        if (response.error) {
            setHours([])
            setOrders([])
            setNoData(true)
        } else {
            setHours(response.data.hours)
            setOrders(response.data.orders)
            setNoData(false)
        }
        setShowLoader(false);
    }

    ChartJS.register(
        CategoryScale,
        LinearScale,
        PointElement,
        LineElement,
        BarElement,
        ArcElement,
        Title,
        Tooltip,
        Legend
    );

    const handleTabSelect = (tabKey) => {
        setFilterConfig((prev) => {
            return {
                ...prev,
                tab: tabKey,
                branch_id: "",
                date_from: "",
                date_to: "",
            };
        });
    };

    useEffect(() => {
        fetchBranches();
    }, [filterConfig.tab]);

    useEffect(() => {
        fetchData();
    }, [filterConfig]);

    return (
        <div>
            <div className="page">
                <Navbar
                    onCollapse={(inactive) => {
                        setInactive(inactive);
                    }}
                    active={"STORE REPORTS"}
                />
            </div>

            <div
                className={`manager-container ${
                    inactive ? "inactive" : "active"
                }`}
            >
                {/* headers */}
                <Row className="mb-4">
                    <Col xs={12} lg={7}>
                        <h1 className="page-title ps-2 ms-3 ms-md-0 ps-md-0 ms-md-0 fs-2"> PEAK HOURS </h1>
                    </Col>
                </Row>

                <div className="tab-content">
                    {/* filters */}
                    <div className="mb-3" />
                    <span className="ps-3 mb-2 align-middle d-none d-md-inline d-flex text-secondary">
                        Filter By:
                    </span>
                    <Row className="PO-filters flex flex-row mx-2 my-1">
                        <Col xs={12} lg={4} className="mb-2 mb-lg-0">
                        <Select
                            className="dropsearch-filter"
                            classNamePrefix="react-select"
                            placeholder="Select Branch"
                            styles={selectDropdownStyle}
                            value={branches.filter((branch) => branch.id === filterConfig.branch_id)}
                            options={branches}
                            onChange={(e) => { setFilterConfig((prev) => {
                                    return { ...prev, "branch_id": e.value };
                                });}}
                        />
                        </Col>
                        <Col xs={6} lg={2}>
                        <DatePicker
                                    autoComplete="off"
                            selected={filterConfig.date_from}
                            name="date_from"
                            placeholderText={Moment().format("MM/DD/YYYY")}
                            onChange={(date) => {
                                setFilterConfig((prev) => {
                                    return { ...prev, date_from: date };
                                });
                            }}
                            fixedHeight
                            className="date-filter me-4 form-control"
                            showYearDropdown
                            dateFormatCalendar="MMMM"
                            yearDropdownItemNumber={20}
                            scrollableYearDropdown
                        />
                        </Col>
                        <Col xs={6} lg={2}>
                        <DatePicker
                                    autoComplete="off"
                            selected={filterConfig.date_to}
                            name="date_to"
                            placeholderText={Moment().format("MM/DD/YYYY")}
                            onChange={(date) => {
                                setFilterConfig((prev) => {
                                    return { ...prev, date_to: date };
                                });
                            }}
                            fixedHeight
                            className="date-filter ps-label-content me-5 form-control"
                            showYearDropdown
                            dateFormatCalendar="MMMM"
                            yearDropdownItemNumber={20}
                            scrollableYearDropdown
                        />
                        </Col>
                    </Row>
                    <div className="mb-2" />

                    <div className="below mb-5">
                        {
                            !noData ? (
                                <>
                                <Row className="display-flex">
                                    <Col xs={1} className="text-center">
                                        <span className="">No. of Orders</span>
                                    </Col>
                                    <Col xs={11}>
                                        <Line className="chart-size" data={data} />
                                    </Col>
                                </Row>
                                <Row className="display-flex mt-1">
                                    <Col xs={1} className="text-center">
                                    </Col>
                                    <Col xs={11} className="text-center">
                                        <span>Time</span>
                                    </Col>
                                </Row>
                                </>
                            ) : (
                                <div className="no-data-cont">
                                    <img src={NoDataImg} alt="no data found" className="no-data-small"/>
                                    <span>Uh Oh! No data found.</span>
                                </div>
                            )
                        }
                    </div>
                    <div className="mb-2" />
                </div>

            </div>

            {/* modals */}
            {/* <Delete
                show={showDeleteModal}
                onHide={handleCloseDeleteModal}
                text="allData"
                onDelete={handleDeleteWastage}
            /> */}
            <Footer/>
        </div>
    );
}
